export default __webpack_public_path__ + "static/media/logo_sedaro_primary_white_text.aecf3a57.png";